import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Check, Clock } from "lucide-react";
import { toast } from "sonner";
import { api, friendlyError } from "@/lib/api";

export function WaitlistTab() {
  const qc = useQueryClient();
  const { data: items = [] } = useQuery({ queryKey: ["host-waitlist"], queryFn: async () => (await api.get("/host/waitlist")).data });
  const approve = async (id) => {
    try { await api.post(`/host/waitlist/${id}/approve`); toast.success("Approved — invite them to complete their RSVP."); qc.invalidateQueries({ queryKey: ["host-waitlist"] }); }
    catch (e) { toast.error(friendlyError(e)); }
  };
  return (
    <div className="space-y-6 animate-fade-in max-w-2xl">
      <div><h1 className="font-serif text-3xl text-espresso">Waitlist</h1><p className="text-inkSoft mt-1">Approve guests when spots open up.</p></div>
      {items.length === 0 ? (
        <div className="rounded-3xl bg-white border border-hair shadow-soft p-10 text-center text-inkSoft" data-testid="waitlist-empty">
          <Clock className="mx-auto text-inkMuted mb-3" /> No one on the waitlist.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((w) => (
            <div key={w.id} className="rounded-2xl bg-white border border-hair p-5 flex items-center justify-between" data-testid={`waitlist-${w.id}`}>
              <div><p className="font-semibold text-espresso">{w.name}</p><p className="text-sm text-inkSoft">{w.phone_display} · Party of {w.party_size}</p></div>
              {w.status === "approved" ? <span className="px-3 py-1.5 rounded-full bg-[#2D6A4F]/10 text-[#2D6A4F] text-sm font-semibold flex items-center gap-1"><Check size={14} /> Approved</span>
                : <button onClick={() => approve(w.id)} className="gold-gradient text-espressoDeep font-bold px-5 py-2.5 rounded-full active:scale-95 transition" data-testid={`waitlist-approve-${w.id}`}>Approve</button>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
